import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes/landing'
import { adminRoutes } from './routes/admin'
import { blogRoutes } from './routes/blogs'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...routes,
    ...adminRoutes,
    ...blogRoutes,
  ],
  scrollBehavior(to, from) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'auto'
      }
    } else {
      return {
        top: 0,
        behavior: 'auto'
      }
    }
  }
})

export default router